module.exports = __webpack_public_path__ + "static/media/styles.module.52016335.scss";


//////////////////
// WEBPACK FOOTER
// ./src/Components/LanguageSelect/styles.module.scss
// module id = 448
// module chunks = 0